// extracted by mini-css-extract-plugin
var _1 = "EditClientDialog_checkBoxLabel__BBnu1";
var _2 = "EditClientDialog_formGroup__6ikPO";
var _3 = "EditClientDialog_horizontal__46Q56";
var _4 = "EditClientDialog_note__e0+i1";
var _5 = "EditClientDialog_visible__qv8Ve";
export { _1 as "checkBoxLabel", _2 as "formGroup", _3 as "horizontal", _4 as "note", _5 as "visible" }
